import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Digital Strategy', path: '/services' },
      { name: 'PMO Leadership', path: '/services' },
      { name: 'Website Development', path: '/services' },
      { name: 'Process Optimization', path: '/services' },
    ],
    resources: [
      { name: 'PM Launchpad', path: '/' },
      { name: 'Portfolio', path: '/' },
      { name: 'Shop', path: '/' },
      { name: 'Privacy Policy', path: '/' },
    ],
    company: [
      { name: 'About Us', path: '/' },
      { name: 'Contact', path: '/contact' },
      { name: 'Book Consultation', path: '/book-consultation' },
      { name: 'Careers', path: '/careers' },
    ],
  };

  return (
    <footer className="bg-charcoal text-warm-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        {/* Top Row */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 pb-12 border-b border-warm-white/20">
          <div>
            <h2 className="font-playfair text-3xl font-semibold mb-3">
              KL Consulting Group
            </h2>
            <p className="font-inter text-base text-warm-white/60 max-w-md">
              Strategic consulting for the modern enterprise.
            </p>
          </div>
        </div>

        {/* Middle Navigation Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Services Column */}
          <div>
            <h3 className="font-inter font-semibold text-base mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="font-inter text-sm text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h3 className="font-inter font-semibold text-base mb-6">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="font-inter text-sm text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-inter font-semibold text-base mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="font-inter text-sm text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Copyright & Social Column */}
          <div className="text-left lg:text-right">
            <p className="font-playfair text-lg mb-2">© {currentYear} KL Consulting Group</p>
            <p className="font-inter text-sm text-warm-white/60 mb-6">All rights reserved</p>
            <div className="flex lg:justify-end space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="mailto:info@klconsultinggroup.com"
                className="text-warm-white/70 hover:text-warm-gold transition-colors duration-300 cursor-pointer w-6 h-6 flex items-center justify-center"
              >
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="pt-12 border-t border-warm-white/20">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            {/* Left: Image */}
            <div className="rounded-2xl overflow-hidden h-48 lg:h-56">
              <img
                src="https://public.readdy.ai/ai/img_res/244e0fdbeaaab95c72b147bfbd0a65e0.jpg"
                alt="KL Consulting Group workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Center: Quote */}
            <div className="text-center">
              <blockquote className="font-playfair text-2xl lg:text-3xl leading-relaxed">
                Precision in strategy. <br />
                <em className="text-warm-gold">Excellence</em> in execution. <br />
                Results that matter.
              </blockquote>
            </div>

            {/* Right: Newsletter */}
            <div>
              <h4 className="font-inter font-semibold text-base mb-2">Stay Informed</h4>
              <p className="font-inter text-sm text-warm-white/70 mb-4">
                Get insights on digital strategy, PMO leadership, and industry trends.
              </p>
              <form className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-4 py-3 rounded-l-full bg-transparent border border-warm-white/30 text-warm-white placeholder-warm-white/50 font-inter text-sm focus:outline-none focus:border-warm-gold transition-colors duration-300"
                />
                <button
                  type="submit"
                  className="bg-warm-gold text-charcoal px-6 py-3 rounded-r-full font-inter font-semibold hover:bg-soft-bronze transition-colors duration-300 cursor-pointer whitespace-nowrap w-12 h-12 flex items-center justify-center"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
